<template>
  <div>
    <b-row class='mt-2'>
      <b-col>
        <h4 v-if='item && item.type'>{{item.type.toUpperCase()}}</h4>
      </b-col>
    </b-row>  
    <b-row class='mt-2'>
      <b-col>
        <b-form-file
          accept=".jpg, .png, .gif, .jpeg"
          @change='imageUploaded'
          placeholder='wybierz plik'
        ></b-form-file>
        <div class="text-center mt-3" align-v="center">
          <div class='mb-2'>rozmiar obrazka: {{size}}</div>
          <img :src='imageSrc' style='max-width: 400px;' @load='onImageLoad' />
        </div>
      </b-col>
    </b-row>
    <b-row class='mt-2'>
      <b-col>
        <label>Link</label>
        <b-form-input
          :value='link'
          @input='(e) => actions.handleItemImageLinkChanged(flatPage.id, item.id, e)'
        />
      </b-col>
    </b-row>
    <b-row class='mt-2'>
      <b-col>
        <label>Border radius</label>
        <b-form-input
          type='number'
          :value='borderRadius'
          @input='(e) => actions.handleItemTextStyleChanged(flatPage.id, item.id, "borderRadius", e)'
        />
      </b-col>
      <!--
      <b-col>
        <label>Cien</label>
        <b-form-checkbox
          v-model='modelShadow'
          @input='(e) => actions.handleItemTextStyleChanged(flatPage.id, item.id, "shadow", e)'
          value='true'
          unchecked-value='false'
        >
        </b-form-checkbox>
      </b-col>
      <b-col>
        <label>Kolor cienia</label>
        <b-form-input
          type='color'
          :value='shadowColor'
          @input='(e) => actions.handleItemTextStyleChanged(flatPage.id, item.id, "shadowColor", e)'
        />
      </b-col>
      <b-col>
        <label>Wielkość cienia</label>
        <b-form-input
          type='number'
          :value='shadowSize'
          @input='(e) => actions.handleItemTextStyleChanged(flatPage.id, item.id, "shadowSize", e)'
        />
      </b-col>
      -->
      <b-col>
        <label>Margines górny</label>
        <b-form-input
          type='number'
          :value='marginTop'
          @input='(e) => actions.handleItemTextStyleChanged(flatPage.id, item.id, "marginTop", e)'
        />
      </b-col> 
      <b-col>
        <label>Margines dolny</label>
        <b-form-input
          type='number'
          :value='marginBottom'
          @input='(e) => actions.handleItemTextStyleChanged(flatPage.id, item.id, "marginBottom", e)'
        />
      </b-col>
    </b-row>  
  </div>    
</template>

<script>
  import { mediaROOT } from '@/api'
  import {
    handleItemImageValueChanged,
    handleItemTextStyleChanged,
    handleItemImageLinkChanged,
  } from '@/store/utils.js'
  
  export default {
    props: ['flatPage', 'item'],
    computed: {
      marginTop() {
        try {
          return this.item.style.marginTop || 10
        } catch (e) {
          return 10
        }
      },
      marginBottom() {
        try {
          return this.item.style.marginBottom || 10
        } catch (e) {
          return 10
        }
      },
      shadowColor() {
        try {
          return this.item.style.shadowColor
        } catch (e) {
          return '#000000'
        }
      },
      borderRadius() {
        try {
          return this.item.style.borderRadius || 0
        } catch (e) {
          return 0
        }
      },
      link() {
        try {
          return this.item.link || ''
        } catch (e) {
          return 0
        }
      },
      shadowSize() {
        try {
          return this.item.style.shadowSize || 2
        } catch (e) {
          return 2
        }
      },
      imageSrc() {
        if (this.item.value.base64 != null) return this.item.value.base64
        if (this.item.value.url != null) return mediaROOT + "/" + this.item.value.url
        return ''
      }
    },
    data() {
      return {
        actions: {
          handleItemImageValueChanged,
          handleItemTextStyleChanged,
          handleItemImageLinkChanged,
        },
        mediaROOT: mediaROOT,
        modelShadow: this.item.style && this.item.style.shadow ? this.item.style.shadow : false,
        size: '',
      }
    },
    mounted() {

    },
    methods: {
      updateImageSize(src) {
        var image = new Image()
        image.src = src
        const setSize = this.setSize.bind(this)
        image.addEventListener('load', () => setSize(image))
      },
      onImageLoad() {
        this.updateImageSize(this.imageSrc)
      },
      setSize(image){
        const { width, height } = image
        this.size = `${width} x ${height}`
      },
      handleEmitData(base64) {
        this.updateImageSize(base64)
        this.actions.handleItemImageValueChanged(this.flatPage.id, this.item.id, base64)
      },
      imageUploaded(e) {
        const file = e.target.files[0]
        const reader = new FileReader()

        if (file) reader.readAsDataURL(file)

        const emitData = this.handleEmitData.bind(this)
        reader.addEventListener('load', () => emitData(reader.result), false)
     }
    },
  }

</script>  